// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__3f4Tm","slick-next":"CustomSlider_slick-next__CbBkp"};